import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    profile: {},
    altaImpago: {},
    validation: {},
    messages: [],
    resultadosBusquedaEstados: [],
    resultadosBusquedaCodigoProductos: [],
    codigoPromotor: null,
    esMayorista: false,
    esGranCliente: false,
    clienteUuid: null,
    clienteIdLegal: null,
    idLegal: null,
    cartera: null
  },
  getters: {
    getCarteras: (state) => state.cartera ? state.cartera.results : [],
    getCarterasOperativas: (state) => state.cartera ? state.cartera.results.filter(cartera => cartera.cartera.operativa) : [],
  },
  mutations: {
    setProfile(state, keycloak) {
      state.profile = {
        ...state.profile,
        "name": keycloak.idTokenParsed.name,
        "email": keycloak.idTokenParsed.email,
        "uuid": keycloak.idTokenParsed.uuid,
        "tos": keycloak.idTokenParsed.tos,
        "roles": keycloak.resourceAccess["portal-cliente"].roles
      }
    },
    addDatosCliente(state, datos) {
      state.altaImpago.cliente = datos;
    },
    addCarteraCliente(state, datos) {
      state.cartera = datos;
    },
    setEsGranCliente(state, datos) {
      state.esGranCliente = datos;
    },
    addDatosAcreedor(state, datos) {
      state.altaImpago.acreedor = datos;
    },
    addDatosDeudor(state, datos) {
      state.altaImpago.deudor = datos;
    },
    addDatosDeuda(state, datos) {
      state.altaImpago.deuda = datos;
    },
    addImpagos(state, datos) {
      state.altaImpago.impagos = datos;
    },
    addOrigenImpago(state, datos) {
      state.altaImpago.origen = datos;
    },
    setMessages(state, messages) {
      state.messages = messages
    },
    addMessage(state, message) {
      state.messages.push(message)
    },
    updateResultadosBusquedaEstados(state, message) {
      state.resultadosBusquedaEstados = message
    },
    updateResultadosBusquedaCodigoProductos(state, message) {
      state.resultadosBusquedaCodigoProductos = message
    },
    addValidationCliente(state, data) {
      state.validation.datosCliente = data;
    }
  },
  actions: {
    addDatosCliente(commit, datos) {
      this.commit('addDatosCliente', datos);
    },
    addCarteraCliente(commit, datos) {
      this.commit('addCarteraCliente', datos);
    },
    addDatosAcreedor(commit, datos) {
      this.commit('addDatosAcreedor', datos);
    },
    addDatosDeudor(commit, datos) {
      this.commit('addDatosDeudor', datos);
    },
    addDatosDeuda(commit, datos) {
      this.commit('addDatosDeuda', datos);
    },
    addImpagos(commit, datos) {
      this.commit('addImpagos', datos);
    },
    addOrigenImpago(commit, datos) {
      this.commit('addOrigenImpago', datos);
    },
    addValidationDatosCliente(commit, data) {
      this.commit('addValidationCliente', data)
    }
  }
})

export default store